/**
 * Unique symbol representing a property that is DEFINED in the manifest
 * but has no actual value. Used in subset detection to compare capabilities
 * rather than just values.
 *
 * Key properties:
 * - Never overrides real values
 * - Allows subset detection for groups with same definitions but no values
 * - Decomposes recursively to mark all atomic children
 */
export const SYSTEM_EMPTY = Symbol('SYSTEM_EMPTY');

export type SystemEmpty = typeof SYSTEM_EMPTY;
